export const REMEDIATED_EMAILS_CLARIFICATION =
  'Emails that were deleted, moved to the spam folder, ' +
  'or were flagged with an inline message based on ' +
  'reported and automatically escalated incidents in ' +
  'the selected time frame.'

export const DATE_FILTER_CHANGE = 'IronScales/Dashboard/Home/DATE_FILTER_CHANGE'

export const SCANBACK_CHANGE = 'IronScales/Dashboard/Home/SCANBACK_CHANGE'
